
import CustomTable from "../../../core/components/common/custom-table.component"
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CustomPopper from '../../../core/components/common/custom-popper.component'
import { useEffect, useState } from "react";
import moment from 'moment';
import { useSnackbar } from "notistack";
import PermissionService from "../services/api/permission-service";
import { functionMenuItemsTemplate } from "../utils/functionMenuConfig";
import DeletePermissionModal from "./delete-function.component";
import EditFunctionModal from "./edit-function-modal.component";
import EditFunctionModuleModal from "./edit-function-module-modal.component";

const FunctionsListTable = ({ recordChange, setRecordChange, module, newPermission }) => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openEditModule, setOpenEditModule] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [row, setRow] = useState(null);
    const [rows, setRows] = useState([])
    const { enqueueSnackbar } = useSnackbar();

    const handleRecordChange = () => setRecordChange(true)

    const fetchData = () => {
        PermissionService.listAllPermissions().then((res) => {
            const apiResponse = res.data;
            setRows(apiResponse.data);
        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            });
        });
    };
          
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(()=>{
        if(recordChange) {
            fetchData();
            setRecordChange(false)
        }
    },[recordChange])

    useEffect(() => {
        console.log("newPermission")
        console.log(newPermission)
        if (newPermission) {
            setRows(prevRows => [newPermission.data, ...prevRows]);
        }
    }, [newPermission, module.id]);



    const headers = [
        {label: "ID"},
        {label: "Function"},
        {label: "Description"},
        {label: "Last Date Modified"},
        {label: "Action"}
    ]

    const handleAction = (row, setOpenAction) => {
        setRow(row);
        setOpenAction(true);
    };

    const handleEdit = (row) => { 
        handleAction(row, setOpenEdit);
    };

    const handleDelete = (row) => {
        handleAction(row, setOpenDelete);
    }

    const handleEditModule = (row) => { 
        handleAction(row, setOpenEditModule);
    };

    console.log('get rows data', rows)

    return (
        <div>
            <CustomTable headers={headers}>
               {rows.filter(row => row.module_id === module?.id).length === 0 ? (
    <TableRow>
        <TableCell colSpan={headers.length} align="center">
            No data available
        </TableCell>
    </TableRow>
) : (
    rows
        .filter(row => row.module_id === module?.id)
        .map((row) => {
            let menuItems = functionMenuItemsTemplate(handleEdit, handleDelete, handleEditModule);
            const formattedDate = moment(row.updated_at).format('MMMM Do YYYY, h:mm:ss a');
            return (
                <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.fn}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{formattedDate}</TableCell>
                    <TableCell>
                        <CustomPopper row={row} icon={MoreVertIcon} menuItems={menuItems} />
                    </TableCell>
                </TableRow>
            );
        })
)}

            </CustomTable>
            <EditFunctionModal  row={row} openEdit={openEdit} setOpenEdit={setOpenEdit} handleRecordChange={handleRecordChange}  />
            <EditFunctionModuleModal  row={row} openEditModule={openEditModule} setOpenEditModule={setOpenEditModule} handleRecordChange={handleRecordChange}  />
            <DeletePermissionModal row={row} open={openDelete} setOpen={setOpenDelete} handleRecordChange={handleRecordChange} />
            
        </div>
    )
}

export default FunctionsListTable